// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application--is-rtl .v-date-picker-title .v-picker__title__btn {
  text-align: right;
}
.v-date-picker-title {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: wrap;
  line-height: 1;
}
.v-date-picker-title__year {
  align-items: center;
  display: inline-flex;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}
.v-date-picker-title__date {
  font-size: 34px;
  text-align: left;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  padding-bottom: 8px;
  margin-bottom: -8px;
}
.v-date-picker-title__date > div {
  position: relative;
}
.v-date-picker-title--disabled {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/components/_date-picker-title.styl"],"names":[],"mappings":"AAGE;EACE,iBAAY;AAFhB;AAMA;EACE,aAAS;EACT,8BAAiB;EACjB,sBAAgB;EAChB,eAAW;EACX,cAAa;AAJf;AAMA;EACI,mBAAa;EACb,oBAAS;EACT,eAAW;EACX,gBAAa;EACb,kBAAe;AAJnB;AAMA;EACI,eAAW;EACX,gBAAY;EACZ,gBAAa;EACb,kBAAU;EACV,gBAAU;EACV,mBAAgB;EAChB,mBAAe;AAJnB;AAMI;EACE,kBAAU;AAJhB;AAMA;EACE,oBAAgB;AAJlB","sourcesContent":["@import '../bootstrap'\n\nv-date-picker-title-rtl()\n  .v-picker__title__btn\n    text-align: right\n\nrtl(v-date-picker-title-rtl, \"v-date-picker-title\")\n\n.v-date-picker-title\n  display: flex\n  justify-content: space-between\n  flex-direction: column\n  flex-wrap: wrap\n  line-height: 1\n\n.v-date-picker-title__year\n    align-items: center\n    display: inline-flex\n    font-size: 14px\n    font-weight: 500\n    margin-bottom: 8px\n\n.v-date-picker-title__date\n    font-size: 34px\n    text-align: left\n    font-weight: 500\n    position: relative\n    overflow: hidden\n    padding-bottom: 8px\n    margin-bottom: -8px\n\n    > div\n      position: relative\n\n.v-date-picker-title--disabled\n  pointer-events: none\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
